.tag {
    width: max-content;
    margin-right: unset !important;
    padding: 0 5px !important;

    &[data-size="xs"] {
        padding-top: 1px !important;
        padding-bottom: 2px !important;
        font-size: 10px !important;
        line-height: 10px !important;
    }

    &[data-size="sm"] {
        padding: 0 4px !important;
        font-size: 11px !important;
        line-height: 17px !important;
    }

    /* fix ant default margin */

    &> :global(.anticon)+span,
    &>span+ :global(.anticon) {
        margin-left: 3px !important;
    }
}